import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';
import {
	IVolunteerChartQuery,
	IVolunteerChartsResponse,
	IVolunteerFilter,
	isVolunteerBoardDisabledError,
} from './models';

export const VOLUNTEER_CHARTS_KEY = '/volunteering/charts';

export const useVolunteerChartsQuery = ({
	filter = {},
	charts,
	impersonationContext,
}: {
	filter?: IVolunteerFilter;
	charts: IVolunteerChartQuery[];
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [VOLUNTEER_CHARTS_KEY, filter, charts, impersonationContext?.account?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IVolunteerChartsResponse>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'volunteering/charts' }),
				'POST',
				{ filter, charts }
			),
		meta: {
			toastErrorMessage: (error: Error) =>
				isVolunteerBoardDisabledError(error) ? '' : 'Failed to load the volunteer chart',
		} satisfies LevStandardQueryMeta,
	});
};
